import { useMemo } from "react";
import { ICustomTheme } from "../../../../../context/theme-context";
import { CustomTheme } from "../../../../../types/custom-theme";
import { RowTool, TitleTools } from "../../styles";
import { ColorSelector } from "../selectors/color-selector";
import { GenericSelect } from "../selectors/generic-select";
import { generalFontSize, generalFontWeight } from "../selectors/utils";
import { useTranslation } from 'react-i18next'

export const PaymentMethodSettings = ({
  customTheme,
  handleChangeColor,
  handleSelect,
}: ICustomTheme) => {
  const settings = useMemo(
    () => customTheme.payment_form.settings,
    [customTheme]
  );
  const { t } = useTranslation()

  return (
    <>
      <TitleTools>{t("styles.selectorSections.payMethodSet")}</TitleTools>
      <ColorSelector
        i18n={'styles.fields.background'}
        color={settings.background_color}
        onChange={handleChangeColor.bind(
          null,
          "payment_form.settings.background_color"
        )}
      />

      <ColorSelector
        i18n="styles.fields.textColors"
        color={settings.font_color}
        onChange={handleChangeColor.bind(
          null,
          "payment_form.settings.font_color"
        )}
      />

      <RowTool>
        <GenericSelect
          value={settings.font_size}
          onChange={handleSelect.bind(null, "payment_form.settings.font_size")}
          options={generalFontSize}
          i18n="styles.fields.fontSize"
        />

        <GenericSelect
          value={settings.font_weight}
          onChange={handleSelect.bind(
            null,
            "payment_form.settings.font_weight"
          )}
          options={generalFontWeight}
          i18FromValues
          i18n="styles.fields.fontWeight"
        />
      </RowTool>
    </>
  );
};
